"use client";

import { useEffect } from "react";
import React from "react";

export type PricingTableProps = {
  "pricing-table-id": string;
  "publishable-key": string;
  "customer-session-client-secret": string;
};

const StripePricingTable = (props: PricingTableProps) => {
  useEffect(() => {
    // Stripe is a trusted third-party that updates their script regularly,
    // making SRI impractical as it would break when they deploy updates
    const script = document.createElement("script"); // NOSONAR
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return React.createElement("stripe-pricing-table", {
    "pricing-table-id": props["pricing-table-id"],
    "publishable-key": props["publishable-key"],
    "customer-session-client-secret": props["customer-session-client-secret"],
  });
};

export default StripePricingTable;
